import * as Sentry from '@sentry/browser'
import { Dedupe as DedupeIntegration } from '@sentry/integrations'

export const sentryOptions = {
  dsn: 'https://11de51e753454212a2845e5899a38cae@sentry.io/33153',
  allowUrls: [/finviz\.com/, /www\.finviz\.com/, /elite\.finviz\.com/],
  release: typeof window !== 'undefined' && 'FinvizSentrySettings' in window ? FinvizSentrySettings.release : undefined,
  replaysSessionSampleRate: 0.1, // recording during casual session - 10%
  replaysOnErrorSampleRate: 1.0, // recording after error occurred - 100%
  integrations: [new DedupeIntegration(), new Sentry.Replay()],
}
